<template>
    <div style="display: flex; height: 100%;">
        <v-row style="margin: 0px;">
            <v-col class="tableau">
                <v-data-table 
                        class="rampantTable" 
                        :items="rampants" 
                        :headers="headerRampants" 
                        :items-per-page="-1"
                        :item-class="getRowClass"
                        @click:row="editItem"
                        fixed-header 
                        hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_rampants_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                        small
                        @click.stop="deleteItem(item)"
                        >
                        mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>

            </v-col>
            <v-col class="formulaire">
                <v-row>
                    <v-col class="inputCols">
                        <div class="champs">
                            <div>
                                {{ $t('_nom_rampant_')}}
                            </div>
                            <div class="input ">
                                <v-text-field outlined class="inputField" v-model="reponse.nomRampant.value">

                                </v-text-field>
                            </div>
                        </div>
                        <div class="champs">
                            <div>
                                {{ $t('_inclinaison_rampant_') }}
                            </div>
                            <div class="input">
                                <v-text-field outlined class="inputField" v-model="reponse.inclinaisonRampant.value" onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))">
                                </v-text-field>
                                <div class="unit">
                                    {{ $t('_degre_') }}
                                </div>
                            </div>
                        </div>
                        <div class="champs">
                                <div class="ligne">
                                    <div>
                                        {{ $t('_orientation_pv_') }} (*)
                                    </div>
                                    <div class="complement">
                                        - {{ $t('_azimut_nord_') }}
                                    </div>
                                </div>
                                <div class="input">
                                    <v-text-field outlined class="inputField" v-model="reponse.orientationPV.value" onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))">
                                    </v-text-field>
                                    <div class="unit">
                                        {{ $t('_degre_') }}
                                    </div>
                                </div>
                        </div>
                        <div class="champs">
                            <div>
                                {{ $t('_inclinaison_PV_') }} (*)
                            </div>
                            <div class="input">
                                <v-text-field outlined class="inputField" v-model="reponse.inclinaisonPV.value" onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))">
                                </v-text-field>
                                <div class="unit">
                                    {{ $t('_degre_') }}
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col class="inputCols">
                        <div class="champs">
                            <div>
                                {{ $t('_hauteur_pv_relative_') }}
                            </div>
                            <div class="input">
                                <v-text-field outlined class="inputField" v-model="reponse.hauteurPV.value" onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))">
                                </v-text-field>
                                <div class="unit">
                                    m
                                </div>
                            </div> 
                        </div>
                        <div class="champs">
                            <div>
                                {{ $t('_type_d_installation_')}} (*)
                            </div>
                            <div>
                                <div class="input">
                                    <select class="createSelect" v-model="reponse.installationChoisie.value">
                                        <option disabled value=""> </option>
                                        <option v-for="(opt,index) in typeInstall" :value="opt.data.key" :key="index"> {{ opt.data.key }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="champs" v-if="reponse.installationChoisie.value === 'Facade' || reponse.installationChoisie.value === 'Toiture'">
                            <div>
                                {{  $t('_type_batiment_') }} (*)
                            </div>
                            <div>
                                <div class="inputField">
                                    <select class="createSelect" v-model="reponse.batChoisi.value">
                                        <option disabled value=""> </option>
                                        <option v-for="(opt,index) in typeBat" :value="opt.data.key" :key="index"> {{ opt.data.key }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="champs" v-if="(reponse.installationChoisie.value === 'Facade' || reponse.installationChoisie.value === 'Toiture') && reponse.batChoisi.value!=='N/A'" >
                            <div>
                                {{ $t('_type_d_integration_') }} (*)
                            </div>
                            <div>
                                <div class="inputField">
                                    <select class="createSelect" v-model="reponse.integrationChoisie.value">
                                        <option disabled value=""> </option>
                                        <option v-for="(opt,index) in typeIntegrations" :value="opt.data.key" :key="index"> {{ opt.data.key }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-btn v-if="!edition" :disabled="!rempli" style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;" @click="addData()">
                    {{ $t('_ajouter_')}}
                </v-btn>
                <div v-else >
                    <v-btn :disabled="!rempli" style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;" @click="editData()">
                        {{ $t('_modifier_')}}
                    </v-btn>
                    <v-btn style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;" @click="cancelEdit()">
                        {{ $t('_annuler_')}}
                    </v-btn>
                </div>
                
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from "@/api/api";

export default {

    props: {
        initRampants : {
            required: false,
        },
        calepinage:{    //est modifier si un rampant y figurant est supprimé
            required: false,
        }
    },

    // pre rempli le formulaire et calepinage avec les données deja enregistées, recupere la liste des types d'installation dans le back d'heliocity
    async mounted(){
        if (this.initRampants !== undefined && this.initRampants !== null) 
            this.rampants = this.initRampants
        this.typeInstall= await api.get_installation()

        let temp = await api.get_building()
        this.typeBat = temp.filter(element => element.data.key!== undefined);
        this.typeIntegrations= await api.get_integration()
        if (this.calepinage!==undefined)
            this.nouveauCalepinage=this.calepinage

    },

    data() {
        return {
            nouveauCalepinage: [],
            rampants: [],
            headerRampants: [
                { key: 'id', text: this.$t('_identifiant_'), value: 'id' },
                { key: 'nomRampant', text: this.$t('_nom_rampant_'), value: 'nomRampant' },
                { key: 'orientationPV', text: this.$t('_orientation_'), value: 'orientationPV' },
                { key: 'inclinaisonPV', text: this.$t('_inclinaison_'), value: 'inclinaisonPV' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ],
            typeInstall: [],  
            typeBat: [],
            typeIntegrations: [],
            rempli: false,
            edition: false,
            indexEdite:null, 
            reponse: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "nomRampant":  {
                    "value": "",
                    "required": false,
                },
                "inclinaisonRampant":  {
                    "value": "",
                    "required": false,
                },
                "orientationPV": {
                    "value": "",
                    "required": true,
                },
                "inclinaisonPV": {
                    "value": "",
                    "required": true,
                },
                "hauteurPV":  {
                    "value": "",
                    "required": false,
                },
                "installationChoisie": {
                    "value": "",
                    "required": true,
                },
                "batChoisi":  {
                    "value": "",
                    "required": false,
                },
                "integrationChoisie": {
                    "value": "",
                    "required": false,
                },
            },
            reponseVide: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "nomRampant":  {
                    "value": "",
                    "required": false,
                },
                "inclinaisonRampant":  {
                    "value": "",
                    "required": false,
                },
                "orientationPV": {
                    "value": "",
                    "required": true,
                },
                "inclinaisonPV": {
                    "value": "",
                    "required": true,
                },
                "hauteurPV":  {
                    "value": "",
                    "required": false,
                },
                "installationChoisie": {
                    "value": "",
                    "required": true,
                },
                "batChoisi":  {
                    "value": "",
                    "required": false,
                },
                "integrationChoisie": {
                    "value": "",
                    "required": false,
                },
            },
        }
    },
    methods: {
        editItem(item) {
            this.edition=true
            this.indexEdite=this.rampants.indexOf(item)
            for (var champ in item){
                this.reponse[champ].value = item[champ]
            }

        },

        getRowClass(item){
            return this.indexEdite === this.rampants.indexOf(item) ? 'lineEdit' : '';
        },

        cancelEdit() {
            this.edition = false
            this.indexEdite = null
            this.$nextTick(() => {
                for (var champ in this.reponseVide){
                    this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                }
                
            })
        },

        editData(){
            if (this.reponse.nomRampant.value === this.reponseVide.nomRampant.value)
                this.reponse.nomRampant.value = "plane-"+ this.reponse.id.value
            for (var champ in this.reponse){
                this.rampants[this.indexEdite][champ]= this.reponse[champ].value
            }
            this.edition=false
            this.indexEdite = null
            this.$nextTick(() => {
                for (var champ in this.reponseVide){
                    this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                }
                
            })
            this.$emit("answer",{"reponse": this.rampants, "calepinage" :this.nouveauCalepinage})
        },

        addData() {
            if (this.rempli){
                this.reponse.id.value = this.rampants.length + 1
                if (this.reponse.nomRampant.value === this.reponseVide.nomRampant.value)
                    this.reponse.nomRampant.value = "plane-"+ this.reponse.id.value
                var justeValeurs = {}
                for (var champ in this.reponse) {
                    justeValeurs[champ] = this.reponse[champ].value
                }
                this.rampants.push(justeValeurs)
                this.$nextTick(() => {
                    for (var champ in this.reponseVide){
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }
                    
                })
                this.$emit("answer",{"reponse": this.rampants, "calepinage" :this.nouveauCalepinage})
            }  
        },

        //recréer calepinage a chaque suppression
        deleteItem(item){
            let newCalepinage= []
            const suppIndex=this.rampants.indexOf(item)
                this.nouveauCalepinage.forEach(calp => {
                    if (calp.idRampant!== item.id){
                        if(calp.idRampant > item.id)
                            calp.idRampant -= 1
                        newCalepinage.push(calp)
                    }
                       
                    
                })
                this.$nextTick(() => {
                for (var i=0; i<newCalepinage.length; i+=1){
                    newCalepinage[i].id = i + 1
                }
            })
                this.nouveauCalepinage=newCalepinage
                
            this.rampants.splice(suppIndex , 1)
            this.$nextTick(() => {
                for (var i=0; i<this.rampants.length; i+=1){
                    this.rampants[i].id = i + 1
                }
            })
            if (this.edition===true){
                this.edition= false
                this.indexEdite = null
                this.$nextTick(() => {
                    for (var champ in this.reponseVide){
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }
                    
                })
            }
            this.$emit("answer",{"reponse": this.rampants, "calepinage" :this.nouveauCalepinage})
        }
    },
    watch: {
        reponse: {
            handler() {
                let nouveauRempli = true
                for (var champs in this.reponse){
                    if (this.reponse[champs].required===true && this.reponse[champs].value===""){
                        nouveauRempli = false
                    }
                }
                if (this.reponse.installationChoisie.value === "Facade" || this.reponse.installationChoisie.value === "Toiture" ){
                    if (this.reponse.batChoisi.value === "" || (this.reponse.batChoisi.value !== "N/A" && this.reponse.integrationChoisie.value === "")){
                        nouveauRempli = false
                    }
                }
                else {
                    this.reponse.batChoisi.value = ""
                    this.reponse.integrationChoisie.value = ""
                }
                this.rempli = nouveauRempli
            },
            deep: true
        },
        rampants: {
            handler(){
                if (this.rampants.length > 0){
                    this.$emit('enable')
                }
                else {
                    this.$emit('disable')
                }
            },
            deep: true
        },
        initRampants:{
            handler(){
                if (this.initRampants !== undefined && this.initRampants !== null) 
                    this.rampants = this.initRampants
            }
        }
    }
}

</script>

<style scoped>


.tableau {
    align-content: center;
    height: 100%;
}

.ligne{
    display: flex;
    flex-wrap: wrap;
    gap: 10px
}

.tableau .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47,47,47,0.5);
    border-radius: 5px;
}

.tableau .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.rampantTable{
    height: 80%;
}

.rampantTable >>> .lineEdit {
    background-color: #d9d9d9;
}

.formulaire {
    align-content: center;
}

.v-messages {
    min-height: 0;
    height: 0;
}

.unit{
    padding: 0;
    padding-left: 12px;
    align-content: center;
    font-weight: normal;
}

.complement {
    font-size: 0.7rem;
    font-weight: normal;
    align-content: center;
}


</style>